if (!customElements.get('advertorial-reviews-carousel')) {
  class AdvertorialReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-reviews-track]')
      this.prev = this.querySelector('[data-reviews-prev]')
      this.next = this.querySelector('[data-reviews-next]')
      this.controls = this.querySelector('[data-reviews-controls]')
      this.slides = Array.from(
        this.querySelectorAll('[data-review-slide]')
      )

      if (
        !this.track ||
        !this.prev ||
        !this.next ||
        !this.slides.length
      ) {
        return
      }

      this.handlePrev = () => this.move(-1)
      this.handleNext = () => this.move(1)
      this.handleUpdate = () => this.update()

      this.prev.addEventListener('click', this.handlePrev)
      this.next.addEventListener('click', this.handleNext)

      this.track.addEventListener(
        'scroll',
        this.handleUpdate,
        { passive: true }
      )

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(
          this.handleUpdate
        )

        this.resizeObserver.observe(this.track)
      } else {
        window.addEventListener(
          'resize',
          this.handleUpdate
        )
      }

      this.track.scrollLeft = 0

      requestAnimationFrame(() => {
        this.track.scrollLeft = 0

        requestAnimationFrame(() => {
          this.update()
        })
      })
    }

    getSlidePosition(slide) {
      const trackRect =
        this.track.getBoundingClientRect()

      const slideRect =
        slide.getBoundingClientRect()

      return (
        slideRect.left -
        trackRect.left +
        this.track.scrollLeft
      )
    }

    getCurrentIndex() {
      const scrollLeft = this.track.scrollLeft

      let currentIndex = 0
      let smallestDistance = Infinity

      this.slides.forEach((slide, index) => {
        let position =
          this.getSlidePosition(slide)

        if (index === 0) {
          position = 0
        }

        const distance = Math.abs(
          position - scrollLeft
        )

        if (distance < smallestDistance) {
          smallestDistance = distance
          currentIndex = index
        }
      })

      return currentIndex
    }

    move(direction) {
      const currentIndex =
        this.getCurrentIndex()

      const targetIndex = Math.max(
        0,
        Math.min(
          this.slides.length - 1,
          currentIndex + direction
        )
      )

      const targetSlide =
        this.slides[targetIndex]

        let targetPosition =
        this.getSlidePosition(targetSlide)

        if (targetIndex === 0) {
        targetPosition = 0
        } else if (window.innerWidth < 640) {
        const styles = getComputedStyle(this.track)
        const scrollPaddingLeft =
            parseFloat(styles.scrollPaddingLeft) || 0

        targetPosition -= scrollPaddingLeft
        }
      const maxScroll =
        this.track.scrollWidth -
        this.track.clientWidth

      targetPosition = Math.max(
        0,
        Math.min(targetPosition, maxScroll)
      )

      this.track.scrollTo({
        left: targetPosition,
        behavior: 'smooth'
      })
    }

    update() {
      const maxScroll =
        this.track.scrollWidth -
        this.track.clientWidth

      const hasOverflow =
        maxScroll > 2

      this.controls.hidden =
        !hasOverflow

      this.prev.disabled =
        this.track.scrollLeft <= 2

      this.next.disabled =
        maxScroll -
          this.track.scrollLeft <=
        2
    }

    disconnectedCallback() {
      this.prev?.removeEventListener(
        'click',
        this.handlePrev
      )

      this.next?.removeEventListener(
        'click',
        this.handleNext
      )

      this.track?.removeEventListener(
        'scroll',
        this.handleUpdate
      )

      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      } else {
        window.removeEventListener(
          'resize',
          this.handleUpdate
        )
      }
    }
  }

  customElements.define(
    'advertorial-reviews-carousel',
    AdvertorialReviewsCarousel
  )
}